import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Grid,
  Row,
  Col,
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import { generate } from 'shortid';
import scriptLoader from 'react-async-script-loader';

import stripeConfig from '../../config/stripe';
import FieldGroup from '../FieldGroup/FieldGroup';
import Loading from '../Shared/Loading';

import './Payment.css';

const stripeJsUrl = "https://js.stripe.com/v3/";

const PaymentForm = observer(
class PaymentForm extends Component {
  constructor(props) {
    super(props);
    this.stripe = null;
    this.card = null;
    this.ids = {
      name: generate(),
      addressLine1: generate(),
      addressLine2: generate(),
      addressCity: generate(),
      addressStateProv: generate(),
      addressZip: generate(),
      addressCountry: generate(),
      stripe: generate(),
      stripeElements: generate(),
    };
  }

  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.initStripe();
    }
  }

  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    // load finished ?
    if (isScriptLoaded && !this.props.isScriptLoaded) {
      if (isScriptLoadSucceed) {
        this.initStripe();
      } else {
        throw new Error("Payment form failed to load");
      }
    }
  }

  render() {
    const {
      creditCardOwnerInfo: ccInfo = {},
      onCancel,
      addingPayment = false,
    } = this.props;

    return (
      <form className="PaymentForm-form" onSubmit={this.onSave}>
        <Grid fluid>
          <Row><Col sm={12}>
            <p>
              <span className="text-danger">* </span>
              Your card info is securely handled by <a href="https://stripe.com/docs/security/stripe" target="_blank" rel="noopener noreferrer"><b> Stripe</b></a>.
            </p>
          </Col></Row>
          <Row><Col sm={12}>
            <FieldGroup
              autoFocus
              id={this.ids.name}
              name="name"
              label="Card holder name"
              placeholder="e.g. John Smith"
              value={ccInfo.name}
              onChange={this.handleChange} />
            <FieldGroup
              id={this.ids.stripeElements}
              name="card"
              label="Credit card number and expiry date"
              componentClass="div" />
            <FieldGroup
              id={this.ids.addressLine1}
              name="addressLine1"
              label="Address line 1"
              placeholder="e.g. 123 Main Street"
              value={ccInfo.addressLine1}
              onChange={this.handleChange} />
            <FieldGroup
              id={this.ids.addressLine2}
              name="addressLine2"
              label="Address line 2"
              placeholder="e.g. Unit 321"
              value={ccInfo.addressLine2}
              onChange={this.handleChange} />
          </Col></Row>
          <Row>
            <Col xs={6}>
              <FieldGroup
                id={this.ids.addressCity}
                name="addressCity"
                label="City"
                placeholder="e.g. Vancouver"
                value={ccInfo.addressCity}
                onChange={this.handleChange} />
            </Col>
            <Col xs={6}>
              <FieldGroup
                id={this.ids.addressStateProv}
                name="addressStateProv"
                label="Province/ State"
                placeholder="e.g. BC"
                value={ccInfo.addressStateProv}
                onChange={this.handleChange} />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <FieldGroup
                id={this.ids.addressCountry}
                name="addressCountry"
                label="Country"
                componentClass="select"
                defaultValue="-1"
                value={ccInfo.addressCountry}
                onChange={this.handleChange}>
                <option disabled value="-1">Select a country</option>
                <option value="Canada">Canada</option>
                <option value="US">US</option>
              </FieldGroup>
            </Col>
            <Col xs={6}>
              <FieldGroup
                id={this.ids.addressZip}
                name="addressZip"
                label="Postal Code"
                placeholder="e.g. V5K 0A1"
                value={ccInfo.addressZip}
                onChange={this.handleChange} />
            </Col>
          </Row>
        </Grid>
        { addingPayment ?
          <ButtonToolbar className="PaymentForm-footer"><Loading text="" /></ButtonToolbar>:
          <ButtonToolbar className="PaymentForm-footer">
            <Button onClick={onCancel} disabled={addingPayment}>Cancel</Button>
            <Button type="submit" bsStyle="success" disabled={addingPayment}>Save payment method</Button>
          </ButtonToolbar>
        }
      </form>
    );
  }

  initStripe = () => {
    // init stripe
    this.stripe = window.Stripe(stripeConfig);
    const elements = this.stripe.elements();
    const style = {
      base: { lineHeight: '20px' }
    };
    this.card = elements.create("card", {style, hidePostalCode: true});
    this.card.mount(`#${this.ids.stripeElements}`);
    // this.card.addEventListener("change", this.handleStripeError);
    // this.card.addEventListener("submit", this.onSave);
  }

  handleStripeError = (error) => {
    alert(error.message || "Sorry, something went wrong");
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    const { creditCardOwnerInfo } = this.props;
    let data = {};
    data[name] = value;
    creditCardOwnerInfo.set(data);
  }

  onSave = async (e) => {
    e && e.preventDefault && e.preventDefault();

    const {
      creditCardOwnerInfo,
      addingPayment,
    } = this.props;

    if (addingPayment) {
      return;
    }

    if (!creditCardOwnerInfo.isValid()) {
      alert("Invalid credit card or billing info");
      return false;
    }

    const cardOwnerInfo = creditCardOwnerInfo.getForStripe();
    const { token, error } = await this.stripe.createToken(this.card, cardOwnerInfo);
    if (error) {
      this.handleStripeError(error);
      return;
    }

    this._onSave(token);

    return false;
  }

  _onSave = (token) => {
    const { onSave } = this.props;
    if (token && onSave) { onSave(token); }
  }
});

const AsyncWrapper = scriptLoader(stripeJsUrl)(PaymentForm);
export default AsyncWrapper;


// WEBPACK FOOTER //
// ./src/components/Payment/PaymentForm.js